// TUT-504 (D26) — o sino do portal: a lista, o "lida" e o silêncio de cada aviso.
import {
  demoAvisosDoPortal,
  demoDefinirPreferenciaDoPortal,
  demoMarcarAvisoDoPortalLido,
  demoPreferenciasDoPortal,
} from "../demo/avisos-do-portal";
import type {
  AvisosDoPortalResponse,
  ChaveDoAvisoDoPortal,
  PreferenciaDoAvisoDoPortal,
} from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDosAvisosDoPortal = {
  /**
   * Rotas `@Portal()` PRÓPRIAS (o sino do escritório é `@AnyMember` e o externo
   * nem o alcança). O recorte — só os avisos do portal, só do alcance de hoje —
   * é do servidor; a tela não refiltra.
   */
  portalAvisos(): Promise<AvisosDoPortalResponse> {
    if (useDemoApi) return Promise.resolve(demoAvisosDoPortal());
    return request<AvisosDoPortalResponse>("/portal/notifications");
  },
  portalMarcarAvisoLido(id: string): Promise<{ ok: boolean }> {
    if (useDemoApi) return Promise.resolve(demoMarcarAvisoDoPortalLido(id));
    return request<{ ok: boolean }>(`/portal/notifications/${encodeURIComponent(id)}/read`, {
      method: "PATCH",
      body: JSON.stringify({}),
    });
  },
  portalPreferenciasDeAviso(): Promise<{ items: PreferenciaDoAvisoDoPortal[] }> {
    if (useDemoApi) return Promise.resolve(demoPreferenciasDoPortal());
    return request<{ items: PreferenciaDoAvisoDoPortal[] }>("/portal/notifications/preferences");
  },
  portalDefinirPreferenciaDeAviso(input: {
    chave: ChaveDoAvisoDoPortal;
    canal: "internal" | "email";
    receber: boolean;
  }): Promise<{ items: PreferenciaDoAvisoDoPortal[] }> {
    if (useDemoApi) return Promise.resolve(demoDefinirPreferenciaDoPortal(input));
    return request<{ items: PreferenciaDoAvisoDoPortal[] }>("/portal/notifications/preferences", {
      method: "PUT",
      body: JSON.stringify(input),
    });
  },
};
